import React from 'react';
import cn from 'classnames';
import styles from './option-item.module.scss';

export default function OptionItem(props) {
   const { label, active, onClick } = props;

   const sortItemClass = cn({
      [styles.container]: true,
      [styles['container--active']]: active,
   });

   return (
      <li className={sortItemClass}>
         <button type="button" onClick={onClick}>
            {label}
         </button>
      </li>
   );
}
